import React from "react";
import classnames from "classnames";

import { gaEvent } from "../../shared/helpers/gtm_tracking";

class FilterToggle extends React.Component {
  constructor(props) {
    super(props);
    const self = this;

    self.state = {
      buttonHidden: true,
      linkHidden: false
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", this.handleScroll);
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps() {
    const self = this;

    self.setState({
      buttonHidden: self.shouldHideButton(),
      searchList: document.getElementById("js-search-list"),
      title: document.getElementById("js-search-title")
    });
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleClick = () => {
    const self = this;
    const { title } = self.state;

    if (title && title.getBoundingClientRect().bottom < 0) {
      title.scrollIntoView();
    }

    self.props.filters.classList.remove("is-hidden");
    gaEvent("Search Page", "Search Filter", "Mobile Btn");
    self.setState({ buttonHidden: true, linkHidden: true });
  };

  shouldHideButton = () => {
    const self = this;
    const docBottom = window.innerHeight;
    const filtersBottom = self.props.filters.getBoundingClientRect().bottom - 30;
    const { searchList } = self.state;
    const resultsBottom = searchList ? searchList.getBoundingClientRect().bottom : docBottom;

    return filtersBottom > 0 || resultsBottom <= docBottom;
  };

  handleScroll = () => {
    const self = this;

    self.setState({ buttonHidden: self.shouldHideButton() });
  };

  render() {
    const self = this;
    const { state } = self;

    return (
      <span>
        <small
          className={classnames(
            "search-filters__link",
            "hide-lap-and-up",
            state.linkHidden && "hide"
          )}
        >
          (<a onClick={self.handleClick}>change</a>)
        </small>

        <span
          className={classnames(
            "mobile-button",
            "button--alt--solid",
            state.buttonHidden && "is-hidden"
          )}
          onClick={self.handleClick}
        >
          <i className="fa fa-sliders-h fa-fw"></i>
        </span>
      </span>
    );
  }
}

export default FilterToggle;



// WEBPACK FOOTER //
// ./components/filters/FilterToggle.jsx